import { CascadiaTextProps } from "@certn/cascadia/foundations/typography/types";
import { css } from "@emotion/css";
import { memo, ReactNode } from "react";

import { Text } from "../../foundations/typography/Text";
import { HoverInfo } from "./HoverInfo";

const truncateStyle = css({
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "100%",
});

const wrapStyle = css({
  minWidth: 0,
  maxWidth: "100%",
  overflow: "hidden",
  "& button": {
    display: "block",
    maxWidth: "100%",
    overflow: "hidden",
    textAlign: "start",
  },
});

export type HoveredTextProps = CascadiaTextProps & {
  testID: string;
  content: ReactNode;
  hoveredText?: string | null;
};

export const HoveredText = memo(function HoveredText({
  content,
  testID,
  hoveredText,
  ...props
}: HoveredTextProps) {
  return (
    <div className={wrapStyle}>
      <HoverInfo
        testID={testID}
        trigger={
          typeof content === "string" ? (
            <Text
              style="form/body-secondary"
              align="start"
              className={truncateStyle}
              color={props.color}
            >
              {content}
            </Text>
          ) : (
            <>{content}</>
          )
        }
        infoContent={<Text {...props}>{hoveredText ?? content}</Text>}
      />
    </div>
  );
});
